// ----------------- START INITIATE CHECKOUT SCRIPT ------------------------------------

// `breeze-initiatecheckout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after purchase
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-317036487");
  window.gtag("event", "initiatecheckout", {
    send_to: ["AW-317036487/EKsdCNXm4J4YEMevlpcB"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",
  });
}
// GOOGLE ADS INITIATE CHECKOUT EVENT CODE END

// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  const user = params.userDetails || {};

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-317036487");

  window.gtag("event", "purchase", {
    send_to: ["AW-317036487/0b7ACMbm4J4YEMevlpcB"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",

    // User details passed for merchant tracking
    customer_name: user.name,
    customer_email: user.email,
    customer_phone: user.phone,
    customer_city: user.city,
    customer_state: user.state,
    customer_postal_code: user.postalCode,
    customer_country_code: user.countryCode,
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}
